// Frontend-only value set for the run-failures surface. See enums/shell.ts for the rationale.

// Display labels for the contract failure-reason enums. Keyed by each union
// so a new reason forces a label here; the value sets are contract enums and
// only the human wording is frontend-only.

import type { CrawlFailureReason } from "contracts/enums/core";
import type { YeetAttemptFailureReason } from "contracts/enums/yeet";

/**
 * Display labels for the contract failure-reason enums. Keyed by each union
 * so a new reason forces a label here. Without a label, the raw enum value
 * would print to the user verbatim.
 */
export const YEET_FAILURE_REASON_LABELS: Record<
  YeetAttemptFailureReason,
  string
> = {
  no_mcp_contact: "No MCP contact — sandbox never reached the backend",
  boot_failed: "Sandbox boot failed",
  agent_error: "Agent crashed",
  timeout: "Timed out",
  budget_exhausted: "Budget exhausted",
};

// Same contract as the yeet labels above, for the page-level crawl failure enum.
export const CRAWL_FAILURE_REASON_LABELS: Record<CrawlFailureReason, string> = {
  fetch_failed: "The page could not be fetched",
  extract_failed: "The page content could not be extracted",
  attempts_exceeded: "Gave up after repeated attempts",
  provider_failed: "The rendering provider failed",
  capture_contract_failed: "The captured page was incomplete",
  artifact_store_failed: "The page evidence could not be stored",
  yeet_attempt_failed: "The analysis of this page failed",
  aborted: "Cancelled before this page finished",
};
